import { CLAIM_STATUS_TEXT, PRODUCT_TYPE, PRODUCT_NAME } from '@constants';
import {
  CoveragePeriodGrid,
  CustomerGrid,
  OrderNumberGrid,
  PriceGrid,
  ReturnMethodGrid,
  CurrencyPriceGrid,
  TextGrid,
  CoverageGrid,
} from './GridItem';

export const RETURN_ASSURANCE_POLICY_DETAIL_GRID = (isShowReturnable) => [[{
  label: 'Coverage period',
  id: 'coveragePeriod',
  format: CoveragePeriodGrid,
}, {
  label: `${isShowReturnable ? PRODUCT_NAME.RETURNABLE : PRODUCT_NAME.RETURN_ASSURANCE} fee`,
  id: 'premium',
  format: CurrencyPriceGrid,
}, {
  label: 'Return method',
  id: 'returnMethod',
  format: ReturnMethodGrid,
}], [{
  label: 'Order number',
  id: 'orderName',
  format: OrderNumberGrid,
}, {
  label: 'Customer',
  id: 'customer',
  format: CustomerGrid,
},
  // {
  //   label: isSeel ? 'Return shipping fee' : 'Total buyback fee',
  //   id: isSeel ? 'totalShippingFee' : 'totalBuybackFee',
  //   format: CurrencyPriceGrid,
  // },
]];

/**
 * Buyer Protection 顶部信息单元格文案
 * TODO: 确定返回数据
 */
export const BUYER_PROTECTION_POLICY_DETAIL_GRID = (isShowDeliveryGuarantee, isShowWorryFreePurchase) => {
  let name = PRODUCT_NAME.SHIPPING_PROTECTION;
  if (isShowDeliveryGuarantee) {
    name = PRODUCT_NAME.DELIVERY_GUARANTEE;
  } else if (isShowWorryFreePurchase) {
    name = PRODUCT_NAME.WORRY_FREE_PURCHASE;
  }
  return [[{
    label: 'Coverage period',
    id: 'coveragePeriod',
    format: CoveragePeriodGrid,
  }, {
    label: `${name} fee`,
    id: 'premium',
    format: CurrencyPriceGrid,
  }, {
    label: 'Order Number',
    id: 'orderName',
    format: OrderNumberGrid,
  }], [{
    label: 'Customer',
    id: 'customer',
    format: CustomerGrid,
  },
  ]];
};

export const SHOPLAZZA_BUYER_PROTECTION_POLICY_DETAIL_GRID = [[{
  label: 'Coverage period',
  id: 'coveragePeriod',
  format: CoveragePeriodGrid,
}, {
  label: 'Buyer Protection fee',
  id: '',
  format: PriceGrid,
}, {
  label: 'Order Number',
  id: 'orderName',
  format: OrderNumberGrid,
}], [{
  label: 'Customer',
  id: 'customer',
  format: CustomerGrid,
},
{
  label: 'Total refunded',
  id: '',
  format: PriceGrid,
},
]];

/**
 * Assured Sale 顶部信息单元格文案
 */
export const ASSURED_SALE_POLICY_DETAIL_GRID = [[{
  label: 'Coverage period',
  id: 'coveragePeriod',
  format: CoveragePeriodGrid,
}, {
  label: 'Assured Sale fee',
  id: 'premium',
  format: CurrencyPriceGrid,
}, {
  label: 'Order Number',
  id: 'orderName',
  format: OrderNumberGrid,
}], [{
  label: 'Customer',
  id: 'customer',
  format: CustomerGrid,
},
]];

/**
 * issue 文案
 * TODO: 确定返回数据
 */
export const POLICY_ISSUE_TEXT = {
  [PRODUCT_TYPE.Return]: {
    date: {
      text: () => 'Submitted on',
      id: 'submittedDate',
    },
    reason: {
      text: 'Return reason',
      id: 'refundReason',
    },
  },
  [PRODUCT_TYPE.Buyer]: {
    date: {
      text: (status) => `${CLAIM_STATUS_TEXT[status]} at`,
      id: '',
    },
    reason: {
      text: 'Issue type',
      id: 'refundReason',
    },
  },
  [PRODUCT_TYPE.Assured]: {
    date: {
      text: (status) => `${CLAIM_STATUS_TEXT[status]} at`,
      id: '',
    },
    reason: {
      text: 'Issue type',
      id: 'refundReason',
    },
  },
};

// resolution 映射 目前只用了title
export const paymentMethods = {
  shopify_refund: {
    value: 'shopify_refund',
    title: 'Return to original payment method',
    time: 'Processing time: 1-3 business days ',
  },
  tremendous: {
    value: 'tremendous',
    title: 'Virtual Visa card',
    time: 'Processing time: within 1 hour',
  },
  gently_refund: {
    value: 'gently_refund',
    title: 'Return to original payment method',
    time: 'Processing time: 1-3 business days ',
  },
  direct_deposit: {
    value: 'direct_deposit',
    title: 'Direct Deposit',
    time: 'Processing time: 1-3 business days',
  },
  instant_transfer: {
    value: 'instant_transfer',
    title: 'Instant Transfer',
    time: 'Processing time: within 1 hour',
  },
  paypal: {
    value: 'paypal',
    title: 'PayPal',
    time: 'Processing time: within 1 hour',
  },
  venmo: {
    value: 'venmo',
    title: 'Venmo',
    time: 'Processing time: within 1 hour',
  },
};

export const EXTENDED_WARRANTY_POLICY_DETAIL_GRID = [[{
  label: 'Coverage period',
  id: 'coveragePeriod',
  format: CoveragePeriodGrid,
}, {
  label: `${PRODUCT_NAME.EXTENDED_WARRANTY} fee`,
  id: 'premium',
  format: CurrencyPriceGrid,
}, {
  label: 'Order Number',
  id: 'orderName',
  format: OrderNumberGrid,
}], [{
  label: 'Customer',
  id: 'customer',
  format: CustomerGrid,
},
]];

export const WORRY_FREE_PURCHASE_POLICY_DETAIL_GRID = [[{
  label: 'Coverage period',
  id: 'coveragePeriod',
  format: CoveragePeriodGrid,
}, {
  label: 'Protection cost',
  id: 'premium',
  format: CurrencyPriceGrid,
}, {
  label: 'Coverage',
  id: 'coverage',
  format: CoverageGrid,
}], [{
  label: 'Order Number',
  id: 'orderName',
  format: OrderNumberGrid,
}, {
  label: 'Customer',
  id: 'customer',
  format: CustomerGrid,
},
]];
